import * as React from "react";
function SvgSquarePencil(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        d="M20 5H7a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V14"
      />
      <path fill="currentColor" d="M25 6l2 2-11 11-3 1 1-3L25 6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSquarePencil);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
